export enum QUALITY_IDENTIFIER {
  DEFAULT_ANDROID = 'default_android',
  HDPI = 'hdpi',
  IOS_1X = '@1x',
  IOS_1X_PHONE = '@1x_phone',
  IOS_1X_TABLET = '@1x_tablet',
  IOS_2X = '@2x',
  IOS_2X_PHONE = '@2x_phone',
  IOS_2X_TABLET = '@2x_tablet',
  IOS_3X = '@3x',
  IOS_3X_PHONE = '@3x_phone',
  MDPI = 'mdpi',
  XHDPI = 'xhdpi',
  XXHDPI = 'xxhdpi',
  XXXHDPI = 'xxxhdpi',
}

export const qualityIdentifierOptions: IOption[] = [
  { label: 'default_android', value: QUALITY_IDENTIFIER.DEFAULT_ANDROID },
  { label: 'mdpi', value: QUALITY_IDENTIFIER.MDPI },
  { label: 'hdpi', value: QUALITY_IDENTIFIER.HDPI },
  { label: 'xhdpi', value: QUALITY_IDENTIFIER.XHDPI },
  { label: 'xxhdpi', value: QUALITY_IDENTIFIER.XXHDPI },
  { label: 'xxxhdpi', value: QUALITY_IDENTIFIER.XXXHDPI },
  { label: '@1x', value: QUALITY_IDENTIFIER.IOS_1X },
  { label: '@2x', value: QUALITY_IDENTIFIER.IOS_2X },
  { label: '@3x', value: QUALITY_IDENTIFIER.IOS_3X },
  { label: '@1x_phone', value: QUALITY_IDENTIFIER.IOS_1X_PHONE },
  { label: '@2x_phone', value: QUALITY_IDENTIFIER.IOS_2X_PHONE },
  { label: '@3x_phone', value: QUALITY_IDENTIFIER.IOS_3X_PHONE },
  { label: '@1x_tablet', value: QUALITY_IDENTIFIER.IOS_1X_TABLET },
  { label: '@2x_tablet', value: QUALITY_IDENTIFIER.IOS_2X_TABLET },
]

export const fileTypeOptions: IOption[] = [
  { label: 'Video', value: 'Video' },
  { label: 'Image', value: 'Image' },
  { label: 'Sound', value: 'Sound' },
]

export const statusOptions: IOption[] = [
  { label: 'Draft', value: 'draft' },
  { label: 'Released', value: 'released' },
  { label: 'Stopped', value: 'stopped' },
  { label: 'Deprecated', value: 'deprecated' },
  { label: 'Draft Aborted', value: 'draft_aborted' },
]

export const FASTLY_PATH = 'https://fastly.mwm-storage.mwmcdn.com/raw_files/'
